/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconKerning = createReactComponent("outline", "kerning", "IconKerning", [["path", { "d": "M16 15v-3.5a2.5 2.5 0 1 1 5 0v3.5m0 -2h-5", "key": "svg-0" }], ["path", { "d": "M3 9l3 6l3 -6", "key": "svg-1" }], ["path", { "d": "M9 20l6 -16", "key": "svg-2" }]]);

export { IconKerning as default };
//# sourceMappingURL=IconKerning.mjs.map
